import { EPaymentPlan, EPlanType } from '@if/core/types'
import { formatCurrency } from '@if/core/utils'
import { Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { CreditApplication } from '../../../../data/types'
import { IFinanceBaseWorksheet } from '../../../../data/types/IFinanceBaseWorksheetSchema'
import { MerchantPaymentPlan } from '../../../../data/types/MerchantPaymentPlan'
import FormattedMerchantPaymentPlan from '../../../ViewCreditApplicationPage/components/FormattedMerchantPaymentPlan'

interface Props {
  worksheet: IFinanceBaseWorksheet
  creditApplication: CreditApplication
  totalObligation: number
  merchantPaymentPlan: MerchantPaymentPlan | null
}

const FinancingSection = ({
  worksheet,
  creditApplication,
  totalObligation,
  merchantPaymentPlan,
}: Props) => {
  const { t } = useTranslation()
  const planName = creditApplication?.normsCreditDecision?.planName ?? EPlanType.Default

  return (
    <Stack direction="column">
      <Typography variant="h6" component="div" gutterBottom>
        {t('taskManager.financing')}
      </Typography>
      <Stack direction="row" justifyContent="space-between" spacing={2}>
        <Typography variant="subtitle1">{t('worksheet.paymentPlan')}&nbsp;:</Typography>
        <Typography variant="subtitle1">
          {worksheet?.paymentPlanId === EPaymentPlan.RegularDailyInterests &&
            t(`EPaymentPlan.${worksheet?.paymentPlanId}`, { ns: 'enum' })}
          {worksheet?.paymentPlanId !== EPaymentPlan.RegularDailyInterests && merchantPaymentPlan && (
            <FormattedMerchantPaymentPlan merchantPaymentPlan={merchantPaymentPlan} />
          )}
        </Typography>
      </Stack>
      <Stack direction="row" justifyContent="space-between" spacing={2}>
        <Typography variant="subtitle1">{t('worksheetCommon.program')} :</Typography>
        <Typography variant="subtitle1">{t(`EPlanType.${planName}`, { ns: 'enum' })}</Typography>
      </Stack>
      <Stack direction="row" justifyContent="space-between" spacing={2}>
        <Typography variant="subtitle1">
          {t('worksheetCommon.interest')} :
          {worksheet?.paymentPlanId === EPaymentPlan.RegularDailyInterests &&
            `(${creditApplication?.finalCreditDecision?.interestRate}%)`}
        </Typography>
        <Typography variant="subtitle1">{formatCurrency(worksheet?.totalInterestAmount)}</Typography>
      </Stack>
      <Stack direction="row" justifyContent="space-between" spacing={2}>
        <Typography variant="subtitle1">{t('worksheetCommon.totalObligation')} :</Typography>
        <Typography variant="subtitle1">{formatCurrency(totalObligation)}</Typography>
      </Stack>
      <Stack direction="row" justifyContent="space-between" spacing={2}>
        <Typography variant="subtitle1">{t('worksheetCommon.annualPercentageRate')} :</Typography>
        <Typography variant="subtitle1">{worksheet?.effectiveRate} %</Typography>
      </Stack>
    </Stack>
  )
}

export default FinancingSection